<template>
  <div>
    <div class="saving" v-if="saving">
      <p>{{saving}}</p>
    </div>
    <div class="col-12 tab-info" v-if="res.tab=='delete'">
      <div class="row action-container">
        <div class="col-12 contact-info">
          <div class="col-12">
            <div class="delete-mask-question">
              Delete this reservation and
              <span class="restore-masks-toggle" @click="restoreMasks= !restoreMasks" v-if="restoreMasks">
                put
              </span>
              <span class="restore-masks-toggle" @click="restoreMasks= !restoreMasks" v-else>
                do not put</span>
              masks back to inventory
            </div>
          </div>
          <div class="col-6-sm">
            <div class="confirm-mask confirm" @click="deleteReservation(res, i)">Do it</div>
          </div>
          <div class="col-6-sm">
            <div class="confirm-mask cancel" @click="toggleTab('delete',i)">Nevermind</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 tab-info" v-if="res.tab=='masks'">
      <Mask-List
        :res="res"
        :i="i"
      />
    </div>
    <div class="col-12 tab-info" v-if="res.tab=='info'">
      <div class="row action-container">
        <div class="col-12 contact-info">
          <div class="col-6 email">
            <a :href="'mailto:' + res.email">{{res.email}}</a>
          </div>
          <div class="col-6 phone hidden-sm" v-if="res.phone">
            <a :href="'tel:' + res.phone">{{res.phone}}</a>
          </div>
          <div class="col-6 phone-mob hidden-lg" v-if="res.phone">
            <a :href="'tel:' + res.phone">{{res.phone}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 tab-payment" v-if="res.tab=='payment'">
      <div class="row action-container">
        <div class="col-12 action-payment" v-if="!res.payment">
          Record Payment:
          <input id="newPaymentAmount" type="tel" placeholder="how much" v-model="newPaymentAmount"/>
          <input id="newEventDate" type="date" v-model="newEventDate">
          <div class="col-12">
            <button class="col-4-sm" @click="savePayment('venmo', res.uuid)">venmo</button>
            <button class="col-4-sm" @click="savePayment('cash', res.uuid)">cash</button>
            <button class="col-4-sm" @click="savePayment('other', res.uuid)">other</button>
          </div>
        </div>
        <div class="col-12 action-payment" v-else >
          ${{res.payment.amount}} on {{formatDate(res.payment.date, 'MM-DD')}} via {{res.payment.method}}
        </div>
      </div>
    </div>
    <div class="col-12 tab-delivery" v-if="res.tab=='delivery'">
      <div class="row action-container">
        <div class="col-12 action-payment" v-if="!res.delivery">
          Record Delivery:
          <input id="newEventDate" type="date" v-model="newEventDate">
          <div class="col-12">
            <button class="col-4-sm" @click="saveDelivery('mail', res.uuid)">mail</button>
            <button class="col-4-sm" @click="saveDelivery('in person', res.uuid)">in person</button>
            <button class="col-4-sm" @click="saveDelivery('other', res.uuid)">other</button>
          </div>
        </div>
        <div class="col-12 action-payment" v-else >
          Delivery: {{res.delivery.method}} on {{formatDate(res.delivery.date)}}
        </div>
      </div>
    </div>
    <div class="col-12 tab-email" v-if="res.tab=='email'">
      <div class="row action-container" v-if="masksComplete(res.masks)">
        <div class="col-12 action-send-email" v-if="!res.emailCompleteSent" @click="sendCompleteEmail(res)">
          Send 'Order Ready' Email
        </div>
        <div class="col-12 action-send-email" v-else >
          Sent {{formatDate(res.emailCompleteSent, 'MM-DD hh:mm a')}}
        </div>
      </div>
      <div class="row action-container" v-else>
        <div class="col-12 action-send-email">
          This order is not complete
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {reservationsRef, fire, masksRef} from '../../../firebase/firebaseConfig.js'
import MaskList from '../components/MaskList.vue'

export default {
  name: 'ReservationCard',
  components: {
    MaskList: MaskList,
  },
  props: {
    res: Object,
    i: Number,
    toggleTab: Function
  },
  mounted() {
  },
  data: function (){
    return {
      saving: false,
      reservations: [],
      show: {},
      summary: {},
      newPaymentAmount: null,
      newEventDate: dayjs().format('YYYY-MM-DD'),
      restoreMasks: true
    }
  },
  methods: {
    deleteReservation(res, i) {
      let vm = this
      vm.saving = 'deleting'
      if(vm.restoreMasks) {
        let masksToRestore = {}
        res.masks.forEach(mask=> {
          if (masksToRestore[mask.uuid]) {
            masksToRestore[mask.uuid]++
          } else {
            masksToRestore[mask.uuid] = 1
          }
        })
        Object.keys(masksToRestore).forEach(maskid => {
          let update = {
            available: fire.firestore.FieldValue.increment(masksToRestore[maskid])
          }
          masksRef.doc(maskid).update(update).then(function() {
          }).catch(function(error) {
            console.log('error', error)
          })
        })
      }
      let path = {
        deleted: new Date(),
        deletePutMaskBack: vm.restoreMasks,
        updated: new Date(),
      }
      reservationsRef.doc(res.uuid).update(path).then(function() {
        vm.saving = false
        vm.toggleTab('delete',i)
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    masksComplete(masks) {
      let complete = true
      masks.forEach(mask=>{
        if (!mask.completed) {
          complete = false
        }
      })
      return complete
    },
    sendCompleteEmail(res) {
      console.log('sending...')
      this.$store.commit('sendCompleteEmail', res)
    },
    formatDate(d, format = 'MM-DD-YYYY') {
      if (d.seconds) {
        return dayjs.unix(d.seconds).format(format)
      } else {
        return dayjs(d).format(format)
      }
    },
    saveDelivery(method, id) {
      let vm = this

      let path = {
        delivery: {
          date: vm.newEventDate,
          method: method
        },
        updated: new Date(),
      }
      vm.reservations = []

      reservationsRef.doc(id).update(path).then(function() {
        console.log('signed, sealed, delivered');
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    savePayment(method, id) {
      let vm = this

      let path = {
        payment: {
          amount: vm.newPaymentAmount,
          date: vm.newEventDate,
          method: method
        },
        updated: new Date(),
      }
      vm.reservations = []

      reservationsRef.doc(id).update(path).then(function() {
        console.log('caching $$$');
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    markComplete(i) {
      if (this.res.masks[i].completed) {
        this.res.masks[i].completed = null;
      } else {
        this.res.masks[i].completed = new Date();
      }
      let updatedMasks = [...this.res.masks]
      let path = {
        masks: updatedMasks,
        updated: new Date(),
      }
      reservationsRef.doc(this.res.uuid).update(path).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .res-header {
    background: $oroGray;
    color: $oroGold;
    font-weight: bold;
    font-size: 18px;
    border-radius: 5px;
  }
  .action-container {
    background: $oroGray;
    color: $oroGold;
    .action-send-email, .action-payment, .contact-info {
      // border: 2px solid black;
      background: $oroGold;
      color: $oroGray;
      border-radius: 5px;
      padding: 5px 0;
      text-align: center;
      button {
        border-radius: 5px;
        border: 2px solid $oroGray;
        background: white;
        background: $oroGray;
        color: $oroGold;
        font-size: 18px;
        padding: 5px 0;
      }
    }
  }
  .email, .phone, .phone-mob {
    a {
      color: $oroGray;
      text-decoration: none;
    }
  }
  .phone {
    text-align: right;
  }
  .phone-mob {
    text-align: center;
  }
  #newPaymentAmount, #newEventDate {
    text-align: center;
  }
  .progress-container {
    .progress-element {
      .progress-button {
        text-align: center;
        border-radius: 5px;
        // color: #060c0e;
        border: 2px solid $oroGold;
      }
        &.complete {
          border-radius: 5px;
          color: $oroGray;
          background: $oroGold;
        }
        &.incomplete {
          border-radius: 5px;
          color: $oroGold;
          background: $oroGray;
        }
        &.selected {
          box-shadow: 0 8px 3px -3px black;
          // background: linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(38,70,83,1) 35%, rgba(233,196,106,1) 100%);
        }

    }
  }
  .delete-mask-question {
  }
  .confirm-mask {
    background: $oroGray;
    color: $oroGold;
    border-radius: 4px;
    padding: 5px;
    .cancel {

    }
    .confirm {

    }
  }
  .restore-masks-toggle {
    background: $oroGray;
    color: $oroGold;
    font-weight: bold;
    border: 1px solid $oroGray;
    padding: 2px 5px;
    border-radius: 4px;
    white-space: nowrap;
  }

    .saving {
      width: 90%;
      position: fixed;
      z-index: 100;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      background: white;
      height: 100px;
      border: 2px solid black;
      border-radius: 5px;
      p {
        height: 100%;
        font-size: 20px;
        color: $oroGray;
        text-align: center;
        font-weight: bold;
        padding: 0;
        margin: 20px auto;
      }
    }
</style>
